export default __webpack_public_path__ + "static/media/crops-icon.d5394ee2.svg";